export default {
	RATE_MANAGEMENT: 'companies/:company_id/rate-management/'
}
